export default (entities) => ({
  createInvitation(invitation) {
    return entities.Invitation.create(invitation);
  },
  updateInvitation(invitation) {
    return entities.Invitation.update(invitation);
  },
});
